import CityPageToldos from "../components/CityPageToldos";

export default function ToldosEstepona() {
  return (
    <CityPageToldos
      name="Estepona"
      slug="estepona"
      cp="29680-29689"
      poblacion={79539}
      zonaGeo="Costa del Sol Occidental"
      lat={36.4276}
      lng={-5.1453}
      zonas={["Centro Histórico", "Cancelada", "Costa Galera", "Selwo"]}
      landmarks={["Plaza de las Flores", "Paseo Marítimo", "Puerto Deportivo"]}
      municipiosLimitrofes={["Marbella", "Benahavís", "Casares"]}
      festivalLocal="Feria y Fiestas Mayores, primera semana de julio"
      contextoTipologico="Pueblo blanco premium frente al mar, urbanizaciones de lujo en expansión, demanda toldos para villas y áticos."
      isCoreZone={true}
    />
  );
}